import NormalizeWheel from '@/utils/normalizeWheel.js';
import Store from '@/stores/store.js'
import Bus from '@/bus/BusEvent.js'
import * as dat from 'dat.gui';

import ControllerGUI from '@/utils/ControllerGUI'

import {
    PointerdownSupport,
    PointermoveSupport
} from './support.js';

export default class abstractCustomScroll {
    constructor(distance, multiplyWheel = 1, $el = window, cb = {}, effectContainer) {
        this.distance = distance
        this.cb = cb;

        this.multiplyWheel = multiplyWheel
        this.$el = $el

        this.isTouch = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0);

        this.isEnable = true;

        this.isAtEnd = false;

        this.scrollX = 0;
        this.scrollY = 0;

        this.pastScrollY = 0;
        this.newScrollY = 0
        this.speed = 0
        this.deltaWheel = 0
        this.effectContainer = effectContainer

        this.x = 0;
        this.y = 0;
        this.lastX = null;
        this.lastY = null;

        this.isScroll = false;
        this.isScrollEnd = false;
        this.hasScroll = false;

        this.update = this.update.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.enable = this.enable.bind(this);
        this.disable = this.disable.bind(this);


        this.cursor = {
            x: 0,
            y: 0,
            oldy: 0,
        },


        this.raf = null;

        this.raf = window.requestAnimationFrame(this.update);

        if (this.isTouch) {
            window.addEventListener(PointerdownSupport(), this.onTouchStart.bind(this), false);
            window.addEventListener(PointermoveSupport(), this.onTouchMove.bind(this), false);
        } else {
            window.addEventListener('wheel', this.onWheel)
        }

        window.addEventListener('mousemove', (_event) => {
            this.setCursor(_event)
        });

    }

    resize(distance) {
        this.distance = distance
        this.clampScroll();
    }

    setCursor(_e) {
        this.cursor.oldy = this.cursor.y
        this.cursor.x = _e.clientX / Store.width
        this.cursor.y = _e.clientY / Store.height
    }

    reset() {
        this.scrollX = 0;
        this.scrollY = 0;

        this.x = 0;
        this.y = 0;
        this.lastX = null;
        this.lastY = null;
    }

    enable() {
        this.isEnable = true;
        
    }

    disable() {
        this.isEnable = false;
    }

    onWheel(event) {
        if (!this.isEnable || Store.state.notFound) return;

        this.wheelVal = NormalizeWheel(event, this.pixelStep, this.lineHeight, this.pageHeight);
        
        //this.wheelVal = event

        // Scroll X
        // -----
        this.scrollX += this.wheelVal.pixelX * this.multiplyWheel;
        this.scrollY += this.wheelVal.pixelY * this.multiplyWheel;
        this.clampScroll();
    }

    onTouchStart(event) {
        this.pointerEvent = event.touches[0];
        this.oldDeltaY = this.scrollY;
        this.startDeltaY = this.pointerEvent.pageY;

        this.oldDeltaX = this.scrollX;
        this.startDeltaX = this.pointerEvent.pageX;

    }

    onTouchMove(event) {

        this.pointerEvent = event.touches[0];

        this.scrollX = this.oldDeltaX - (this.pointerEvent.pageX - this.startDeltaX) * 3;
        this.scrollY = this.oldDeltaY - (this.pointerEvent.pageY - this.startDeltaY) * 3;

        this.clampScroll();
    }

    clampScroll() {
        this.scrollX = this.clampVal(this.scrollX, 0, this.distance.x)
        this.scrollY = this.clampVal(this.scrollY, 0, this.distance.y)

        this.newScrollY = this.scrollY
    }


    clampVal(value, min, max) {
        return min < max
            ? (value < min ? min : value > max ? max : value)
            : (value < max ? max : value > min ? min : value);
    }

    
    scrollSpeedController() {
        this.deltaWheel = this.lerp(this.deltaWheel, (this.newScrollY - this.pastScrollY), 0.1)
        this.speed = this.lerp(this.speed, this.deltaWheel, ControllerGUI.Scroll.inertia )

        if(ControllerGUI.Scroll.enabled_scale_horizontal) {
            if(!ControllerGUI.Scroll.reverse) this.effectContainer.scale.set( 1/ 1 - Math.abs(Math.round(this.speed * ControllerGUI.Scroll.force *100)/10000), 1, 1 );
            else this.effectContainer.scale.set( 1/ 1 + Math.abs(Math.round(this.speed * ControllerGUI.Scroll.force *100)/10000), 1, 1 );
        }    
        
        if(ControllerGUI.Scroll.enabled_scale_vertical) {
            this.effectContainer.scale.set( 1, 1/ 1 + Math.abs(Math.round(this.speed * ControllerGUI.Scroll.force *100)/10000), 1 );
        }

        this.pastScrollY = this.newScrollY


        if(ControllerGUI.Scroll.enabled_skew_horizontal) {
            if(ControllerGUI.Scroll.reverse_skew) this.skewChildren((Math.round(this.speed*100)/10000))
            else this.skewChildren(-(Math.round(this.speed*100)/10000))
        }    
        
    }

    
    skewMesh(mesh) {
        
        var Syx = 0,
            Szx = 0,
            Sxy = 0,
            Szy = 1,
            Sxz = 0,
            Syz = 0;

        
        var matrix = new THREE.Matrix4();

        matrix.set(   1,   0,  0,  0,
                    1,     1,  0,  0,
                    0,   0,   1,   0,
                    0,     0,   0,   1  );
    

        mesh.applyMatrix4( matrix );
    }

    skewChildren(speed) {
        /***
         * n² complexity, not to put in final build 
         */
        this.effectContainer.children.forEach(children => {
            children.children.forEach(grand_child => {
                if(typeof grand_child.material.uniforms !== 'undefined' ) grand_child.material.uniforms.skew.value = speed * ControllerGUI.Scroll.force_skew
            });
        });
    }


    goToScroll(x, y) { 
        this.scrollX = x;
        this.scrollY = y;

        this.clampScroll();
    }

    lerp(min, max, fraction) {
        return (max - min) * fraction + min;
    }

    update() {
        if (this.isEnable) {
            if (Math.abs(this.scrollX - this.x) > 0.1) {
                this.x += (this.scrollX - this.x) * 0.1;
                
            }
            if (Math.abs(this.scrollY - this.y) > 0.1) {
                this.y += (this.scrollY - this.y) * 0.1;
            }
            Store.scrollPosition = this.y
            Store.scrollDistance = this.distance.y

            if ((this.distance.y) - this.y < 2) {
                if (!this.isAtEnd) this.isAtEnd = true;
            } else {
                if (this.isAtEnd) this.isAtEnd = false;
            }
            if (this.lastX !== this.x || this.lastY !== this.y) {
                this.cb(this.x, this.y);

                this.lastX = this.x;
                this.lastY = this.y;
            }

            if(ControllerGUI.Scroll.enabled) this.scrollSpeedController()

            if(Store.state.notFound && Store.isDesktop) {
                this.scrollY = this.lerp(this.scrollY, this.cursor.y * (this.distance.y - Store.height), 0.1) 
                this.speed = this.lerp(this.speed, Math.round((this.cursor.y - this.cursor.oldy)* 100 ) * 100, 0.001) 
            } 
        }
        


        this.raf = window.requestAnimationFrame(this.update);
    }


    destroy() {
        if (!!this.raf) cancelAnimationFrame(this.raf);

        this.$el.removeEventListener(PointerdownSupport(), this.onTouchStart, false);
        this.$el.removeEventListener(PointermoveSupport(), this.onTouchMove, false);
    }
}